import React from 'react'
import './Contact.css'
function Contact() {
  return (
    <div className="sideline" onClick={() => window.location.href = process.env.REACT_APP_LINE}>
      <i className="fab fa-line"></i>
    </div>
  )
}

export default Contact